import { UPDATE_COLLABRATOR_DATA, UPDATE_COLLABRATOR_LIST, UPDATE_SELECTED_COLLABRATOR } from "./keys";

const initialState = {
    collabratorList: [],
    selectedCollabratorToken: null,
    selectedCollabrator:null
}

export default function reducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_COLLABRATOR_LIST: {
            const selectedCollab = payload.length>0?payload.filter((collab)=>collab.userId===JSON.parse(localStorage.getItem('ownerId')))[0]:null;
            return { ...state, collabratorList: payload,selectedCollabrator: selectedCollab,selectedCollabratorToken: selectedCollab ? selectedCollab.collabratorAccessToken:null}
        }
        case UPDATE_SELECTED_COLLABRATOR: {
            return { ...state, selectedCollabratorToken: payload.collabratorAccessToken,selectedCollabrator:payload }
        }
        case UPDATE_COLLABRATOR_DATA: {   
            const { data, id } = action.payload;
            return updateCollabratorData(state, data, id ) 
       } 

        default:
            return { ...state };
    }
}

const updateCollabratorData = (state, data, id) => {
    const { collabratorList } = state;
    const collaborators = collabratorList?.map((collaborator) => {
        if (collaborator.userId === id) {
            const { is_mfa_enable, mfa_token, ...restCollaborator } = collaborator;
            const { is_mfa_enable: _, mfa_token: __, ...restData } = data;
            return { ...restCollaborator, ...restData };
        }
        return collaborator;
    });
    return { ...state, collabratorList: collaborators };
}